
<!-- 课程详情页 -->
<!-- 会显示一个课程的所有章节-->
<template>
  <div class="box">
    
    <!-- 刷新按钮-->
    <div @click="refreshPages">
      <img src="../assets/refresh-2.jpg" class="turn" style="  position: fixed;right: 0px;top: 0px;width: 80px;height:80px;z-index:9999;border-radius:100px; " id="musicStopIco">
    </div>
    <div @click="back">
      <img src="../assets/exit-2.jpg" class="turn" style="  position: fixed;left: 0px;top: 0px;width: 80px;height:80px;z-index:9999; " id="musicStopIco">
    </div>
<!--    <div @click="showModal">-->
<!--      <img src="../assets/logo2.png" class="turn" style="  position: fixed;right: 0px;top: 0px;width: 80px;height:80px;z-index:9999;border-radius:100px; " id="musicStopIco">-->
<!--    </div>-->




    <div class="modalBox" :style="{'display':modalsShow}">

      <div style="position: fixed;right: 16%;top: 16%;" @click="hiddenModal">
        <img src="../assets/del.png" width="30px;">
      </div>
      <img src="../assets/wx/5.png" width="80%" style="margin-top: 60px;">

    </div>
    <div class="container">
      <div v-for="(lesson ,index) in lessonList" class="imgBox">
        <img :src="lesson.topic_front_image" class="lessonimg"  @click="toLesson(lesson.id,lesson.lesson)">
      </div>
      <div  class="imgBox">
      </div>
    </div>

  </div>
</template>

<script>

  import myHttp from '../utils/http'

  export default {
    name: "Course",
    data:function(){
      return{
        lessonList:[

        ],
        course_id:'',
        modalsShow:'none',
      }
    },
    mounted() {
      window.scrollTo(0,0);
      this.findCourseList();
    },
    methods:{
      //返回
      back(){
        this.$router.back();
      },
      //进入课件
      toLesson(lesson_id,lesson){
        console.log('lesson_id:'+lesson_id);
        //  this.$router.push("/lesson");
        window.localStorage.setItem('lesson',lesson)
        this.$router.push({
          name:'Lesson',
          query:{
            lesson_id:lesson_id,
            course_id:this.course_id,
            // user_id:window.localStorage.getItem('id')
            user_id:this.GLOBAL.userId
          }
        });
      },
      //查询所有课程目录
      findCourseList(){
        let index =this.$route.query.index;
        let course_id =this.$route.query.course_id;
        this.course_id =this.$route.query.course_id;
        // let userId =window.localStorage.getItem('id');
        let userId =this.GLOBAL.userId;
        console.log(index+' '+course_id+' '+userId);
        myHttp.get(this.GLOBAL.serverURL+'api/app/lessons?course_id='+course_id,{
          params:{
            token:window.localStorage.getItem('token'),
            course_id:course_id,
          }
        }).
        then(res =>{
          // if((res.config.headers.authorization!=undefined)||(res.config.headers.authorization!='')){
          //    window.localStorage.setItem('token',res.config.headers.authorization);
          // }else{
          //   if((res.config.params.token!=undefined)||(res.config.params.token!=''))
          //   window.localStorage.setItem('token',res.config.params.token);
          // }

          // window.localStorage.setItem('token',res.headers.token);
          this.lessonList =res.data;
          if(this.lessonList.length==0){
            this.$router.replace("/noCourse");
          }

          return res;
        }).catch( err =>{
          console.log('%c catch...','color:red;font-size:15px;');
          console.log(err);
        }).finally(e =>{

        })
      },
      // 刷新页面
      refreshPages(){
          this.$router.push('/refresh');
      },
      //弹出弹出框
      showModal(){
        this.modalsShow='inline';
      },
      //隐藏弹出框
      hiddenModal(){
        this.modalsShow='none';
      }
    },
    //路由离开前 判断是否需要缓存
    beforeRouteLeave(to,from,next){
      console.log('to:...  ');
      console.log(to.name);
      if(to.name=='Home'){
        to.meta.keepAlive = true;     //回到Home 主页   需要缓存
        console.log('if ');
      }else{
        to.meta.keepAlive = false;     //回到其他页   不需要缓存
        console.log('else');
      }

      next();
    }
  }

  console.log("这是课程页");
</script>

<style scoped>

  .box{
    display: -webkit-flex;
    flex-wrap: wrap;
    justify-content: center;
    /*align-content: space-between;*/
    /*background-color: #fa84a1;*/
    /*margin-top: 47px;*/
    width: 100%;
    /*height: 100%;*/
  }


  .container{
    width: 100%;
    /*!*height: 100%;*!   加了这行代码苹果浏览器的高度会变化*/
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-top: 80px;
    margin-left: 3px;
    margin-right: 5px;
  }

  .imgBox{
    width: 32%;
    padding-left: 1%;
    /*background: cadetblue;*/
    /*border: black solid 1px;*/
  }
  .lessonimg{
    width: 100%;
    border-radius: 5px;
    margin-top: 10px;
    margin-bottom: 30px;
    border-radius: 28px;
  }
  .modalBox{
    position: fixed;
    background-color: #f8faf4;
    width: 70%;
    height: 70%;
    left: 15%;
    top:15%;
    overflow: auto;
    box-shadow: 0px 0px 10px 5px #232122;
  }
</style>



// WEBPACK FOOTER //
// src/views/Course.vue